/* Pack to Plate — animated topographic contour background
   Marching squares over fractal simplex noise, drawn on a fixed canvas. */
(function () {
  'use strict';

  /* ---- compact 2D simplex noise (public-domain style implementation) ---- */
  function Simplex(seed) {
    var grad = [[1,1],[-1,1],[1,-1],[-1,-1],[1,0],[-1,0],[0,1],[0,-1]];
    var p = new Uint8Array(256);
    var i, j, t;
    for (i = 0; i < 256; i++) p[i] = i;
    var s = seed >>> 0;
    function rnd() { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }
    for (i = 255; i > 0; i--) { j = (rnd() * (i + 1)) | 0; t = p[i]; p[i] = p[j]; p[j] = t; }
    var perm = new Uint8Array(512);
    for (i = 0; i < 512; i++) perm[i] = p[i & 255];
    var F2 = 0.5 * (Math.sqrt(3) - 1), G2 = (3 - Math.sqrt(3)) / 6;
    return function (xin, yin) {
      var n0 = 0, n1 = 0, n2 = 0;
      var sf = (xin + yin) * F2;
      var ix = Math.floor(xin + sf), iy = Math.floor(yin + sf);
      var tg = (ix + iy) * G2;
      var x0 = xin - (ix - tg), y0 = yin - (iy - tg);
      var i1 = x0 > y0 ? 1 : 0, j1 = x0 > y0 ? 0 : 1;
      var x1 = x0 - i1 + G2, y1 = y0 - j1 + G2;
      var x2 = x0 - 1 + 2 * G2, y2 = y0 - 1 + 2 * G2;
      var ii = ix & 255, jj = iy & 255;
      var t0 = 0.5 - x0 * x0 - y0 * y0;
      if (t0 > 0) { var g0 = grad[perm[ii + perm[jj]] & 7]; t0 *= t0; n0 = t0 * t0 * (g0[0] * x0 + g0[1] * y0); }
      var t1 = 0.5 - x1 * x1 - y1 * y1;
      if (t1 > 0) { var g1 = grad[perm[ii + i1 + perm[jj + j1]] & 7]; t1 *= t1; n1 = t1 * t1 * (g1[0] * x1 + g1[1] * y1); }
      var t2 = 0.5 - x2 * x2 - y2 * y2;
      if (t2 > 0) { var g2 = grad[perm[ii + 1 + perm[jj + 1]] & 7]; t2 *= t2; n2 = t2 * t2 * (g2[0] * x2 + g2[1] * y2); }
      return 70 * (n0 + n1 + n2);
    };
  }

  var canvas = document.getElementById('ptp-contours');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  var noise = Simplex(1337);
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var W = 0, H = 0, dpr = 1, cols = 0, rows = 0, field = null;
  var CELL = 11;            /* grid cell size in css px — smaller = shorter, smoother segments */
  var LEVELS = 12;          /* contour levels between -1..1 */
  var SCALE = 0.0016;       /* noise frequency */
  var z = 0;                /* time axis */
  var mouse = { x: 0.5, y: 0.5, tx: 0.5, ty: 0.5 };
  var scrollDrift = 0;

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    /* fill the host section (which can be taller than the viewport), not just innerHeight */
    var host = canvas.parentElement || document.documentElement;
    W = host.clientWidth || window.innerWidth;
    H = host.clientHeight || window.innerHeight;
    canvas.width = W * dpr; canvas.height = H * dpr;
    canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    cols = Math.ceil(W / CELL) + 2;
    rows = Math.ceil(H / CELL) + 2;
    field = new Float32Array(cols * rows);
  }

  function fbm(x, y, zz) {
    return noise(x, y) * 0.65 + noise(x * 2.1 + zz * 50, y * 2.1 - zz * 30) * 0.35;
  }

  function computeField() {
    var oy = scrollDrift, idx = 0;
    var mx = (mouse.x - 0.5) * 120, my = (mouse.y - 0.5) * 120;
    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < cols; c++) {
        var x = (c * CELL + mx) * SCALE;
        var y = ((r * CELL) + oy + my) * SCALE;
        field[idx++] = fbm(x + z, y - z * 0.6, z);
      }
    }
  }

  /* marching squares: stroke each contour level */
  function drawLevel(threshold, strokeStyle, lineWidth) {
    ctx.strokeStyle = strokeStyle;
    ctx.lineWidth = lineWidth;
    ctx.beginPath();
    for (var r = 0; r < rows - 1; r++) {
      for (var c = 0; c < cols - 1; c++) {
        var i0 = r * cols + c;
        var a = field[i0], b = field[i0 + 1], d = field[i0 + cols], e = field[i0 + cols + 1];
        var state = (a > threshold ? 8 : 0) | (b > threshold ? 4 : 0) | (e > threshold ? 2 : 0) | (d > threshold ? 1 : 0);
        if (state === 0 || state === 15) continue;
        var x = c * CELL, y = r * CELL;
        function lerp(v0, v1) { var dv = v1 - v0; return dv === 0 ? 0.5 : (threshold - v0) / dv; }
        var top = { x: x + CELL * lerp(a, b), y: y };
        var bot = { x: x + CELL * lerp(d, e), y: y + CELL };
        var lef = { x: x, y: y + CELL * lerp(a, d) };
        var rig = { x: x + CELL, y: y + CELL * lerp(b, e) };
        var segs;
        switch (state) {
          case 1: case 14: segs = [[lef, bot]]; break;
          case 2: case 13: segs = [[bot, rig]]; break;
          case 3: case 12: segs = [[lef, rig]]; break;
          case 4: case 11: segs = [[top, rig]]; break;
          case 5:          segs = [[top, lef], [bot, rig]]; break;
          case 6: case 9:  segs = [[top, bot]]; break;
          case 7: case 8:  segs = [[top, lef]]; break;
          case 10:         segs = [[top, rig], [lef, bot]]; break;
        }
        for (var s = 0; s < segs.length; s++) {
          ctx.moveTo(segs[s][0].x, segs[s][0].y);
          ctx.lineTo(segs[s][1].x, segs[s][1].y);
        }
      }
    }
    ctx.stroke();
  }

  function draw() {
    computeField();
    ctx.clearRect(0, 0, W, H);
    for (var l = 0; l < LEVELS; l++) {
      var t = -0.9 + (1.8 * l) / (LEVELS - 1);
      if (l === Math.floor(LEVELS / 2)) {
        drawLevel(t, 'rgba(185,151,91,0.55)', 1.4);       /* gold index line */
      } else if (l % 3 === 0) {
        drawLevel(t, 'rgba(90,69,34,0.20)', 1.1);          /* dirt emphasis */
      } else {
        drawLevel(t, 'rgba(90,69,34,0.11)', 1);            /* dirt hairline */
      }
    }
  }

  var raf;
  function loop() {
    z += 0.000065;
    mouse.x += (mouse.tx - mouse.x) * 0.04;
    mouse.y += (mouse.ty - mouse.y) * 0.04;
    scrollDrift = window.scrollY * 0.22;
    draw();
    raf = requestAnimationFrame(loop);
  }

  window.addEventListener('resize', function () { resize(); if (reduced) draw(); });
  /* fonts loading later can grow the hero — re-measure once everything settles */
  window.addEventListener('load', function () { resize(); if (reduced) draw(); });
  window.addEventListener('pointermove', function (e) {
    mouse.tx = e.clientX / W; mouse.ty = e.clientY / H;
  }, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { cancelAnimationFrame(raf); }
    else if (!reduced) { loop(); }
  });

  resize();
  if (reduced) {
    draw();
    window.addEventListener('scroll', function () { scrollDrift = window.scrollY * 0.22; draw(); }, { passive: true });
  } else {
    loop();
  }
})();
